module.exports = __webpack_public_path__ + "img/antes_despues_205.5ebcb50f.png";